import "./App.css";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { Deckbuilder } from "./Deckbuilder";
import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <BrowserRouter>
      <div className="App .container-fluid colorBG">
        <div className="wide100per colorBGBlack">
          <a href="https://www.warcaste.com/">
            <img
              src="../assets/images/Warcaste_TCG.png"
              className="imgNoRadius h130px"
            ></img>
          </a>
        </div>

        <Routes>
          <Route path="/" element={<Deckbuilder />} />
          <Route path="/Deckbuilder" element={<Deckbuilder />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
